/**
 * @generated SignedSource<<365a7a39dafab77469021dc70a68cad8>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TeamHeaderProfileButton_storeUser$data = {
  readonly user: {
    readonly " $fragmentSpreads": FragmentRefs<"Avatar_user">;
  };
  readonly " $fragmentType": "TeamHeaderProfileButton_storeUser";
};
export type TeamHeaderProfileButton_storeUser$key = {
  readonly " $data"?: TeamHeaderProfileButton_storeUser$data;
  readonly " $fragmentSpreads": FragmentRefs<"TeamHeaderProfileButton_storeUser">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TeamHeaderProfileButton_storeUser",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "User",
      "kind": "LinkedField",
      "name": "user",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "Avatar_user"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "StoreUser",
  "abstractKey": null
};

(node as any).hash = "59f3908d431ea0e3391a16f0a3a41c90";

export default node;
